import React from 'react';
import s from './s.module.less';
import PrescriptionsLandingPage from './PrescriptionsLandingPage';
import PrescriptionsRegisterPage from './PrescriptionsRegisterPage';
import PrescriptionsDashboradPage from './PrescriptionsDashboradPage';
import useGetPPAPaymentInfo from 'hooks/useGetPPAPaymentInfo';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import { EPayProviderListType } from 'types/provider';
import { Spin } from 'antd';
import useGetEligibleStatus from 'hooks/textVisit/useGetEligibleStatus';
import AIChat from 'components/AIChat';
import { EAIChatPageId } from 'types/ai';
import commonS from 'styles/common.module.less';

const PrescriptionsPage = () => {
    const [hasPaidPrescriptions, setHasPaidPrescriptions] = React.useState<boolean>();
    const [hasRegister, setHasRegister] = React.useState<boolean>();
    const [paymentInfo, loading, , refetch] = useGetPPAPaymentInfo();
    const [homeInfo] = useProviderHomeInfo();
    const [eligibleStatus, loadingEligibleStatus, fetchEligibleStatus] = useGetEligibleStatus();

    React.useEffect(() => {
        if (!homeInfo || !eligibleStatus) return;
        const hasPay =
            homeInfo &&
            homeInfo.payProviderList &&
            homeInfo.payProviderList?.includes(EPayProviderListType.KLARITY_E_PRESCRIPTIONS);
        setHasPaidPrescriptions(hasPay);
        const _hasRegister = !!eligibleStatus?.completedScriptSureOnboarding;
        setHasRegister(_hasRegister);
        //todo
        //setHasRegister(false);
    }, [homeInfo, eligibleStatus]);
    return (
        <div className={s.wrap}>
            {hasPaidPrescriptions === undefined && <Spin />}
            {hasPaidPrescriptions === false && (
                <PrescriptionsLandingPage
                    onPaymentInfoChange={() => {
                        refetch();
                    }}
                    paymentInfo={paymentInfo}
                    onPaidPrescriptions={() => {
                        setHasPaidPrescriptions(true);
                    }}
                />
            )}
            {hasPaidPrescriptions === true && !hasRegister && (
                <PrescriptionsRegisterPage
                    onFinish={() => {
                        setHasRegister(true);
                    }}
                />
            )}
            {hasPaidPrescriptions === true && hasRegister && <PrescriptionsDashboradPage />}
            <div className={commonS.chatWrap}>
                <AIChat pageId={EAIChatPageId.PROVIDER_PRESCRIPTIONS} defaultShow={false} makeFix={false} />
            </div>
        </div>
    );
};

export default PrescriptionsPage;
